import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-yplpay",
  "use": "icon-icon-yplpay-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-yplpay\"><path d=\"M960 0a64 64 0 0 1 64 64v477.12a64 64 0 0 1-64 64h-192V256H418.88v349.12H768V960a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64V320a64 64 0 0 1 64-64h354.88V64a64 64 0 0 1 64-64H960z m-285.12 325.76c12.864 0 23.296 10.496 23.296 23.36V512c0 12.8-10.432 23.296-23.296 23.296H512A23.296 23.296 0 0 1 488.704 512V349.12c0-12.864 10.432-23.296 23.296-23.296h162.88z\" p-id=\"2618\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol